import { render, staticRenderFns } from "./need-check.vue?vue&type=template&id=240e2e60&scoped=true&"
import script from "./need-check.vue?vue&type=script&lang=js&"
export * from "./need-check.vue?vue&type=script&lang=js&"
import style0 from "./need-check.vue?vue&type=style&index=0&id=240e2e60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240e2e60",
  null
  
)

export default component.exports